import React from 'react';
import request, { METHODS } from '@/api'
import { useEffect, useState } from 'react'
import {
  SEditor,
  SDrawerOrModal,
} from 'shj-components'
import {Form, Input, Select, message, DatePicker, InputNumber, Tooltip} from 'antd';
import dayjs from 'dayjs';
import {
  submitEffecive,
  getSignBillIntentEnum,
  getHouseStatusEnum,
  getHouseNatureEnum
} from '@/services/customerServices';
import { getRealEstateList } from '@/services/homeService';
import styles from './index.module.less'
import {callValid} from "@/services/callCenter";
import {clueSalesValid} from "@/services/saleOpServices.ts";
import {QuestionCircleOutlined} from "@ant-design/icons";

export default function SubmitEffectiveModal ({
  editId = '',
  title = '',
  open = false,
  buttonKey = '',
  basicInfo = {},
  onClose = () => {},
  reload = () => {},
})  {
  const [ form ] = Form.useForm();
  const [dictionaryData, setDictionaryData] = useState({});
  const [buildOptions, setBuildOptions] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);
  const houseStatus = Form.useWatch('houseStatus', form)

  useEffect(() => {
    // if(open) console.log(basicInfo.houseInfo)
    form.setFieldsValue({
      buildingId: (basicInfo as any)?.buildingId,
      houseStatus: (basicInfo as any)?.houseInfo?.houseStatus,
      houseNatureCode: (basicInfo as any)?.houseInfo?.houseNatureCode,
      handoverDate: (basicInfo as any)?.houseInfo?.handoverDate ? dayjs((basicInfo as any)?.houseInfo?.handoverDate) : null,
      constructArea: (basicInfo as any)?.houseInfo?.constructArea,
      innerArea: (basicInfo as any)?.houseInfo?.innerArea,
      signIntentionCode: (basicInfo as any)?.dtlInfo?.signIntentionCode,
    })
    fetchDictionaryData();
  }, [open]);

  const fetchDictionaryData = async () => {
    try {
      const buildingList = await getRealEstateList({handleFlag: true});
      if (buildingList instanceof Array) {
        const options = buildingList?.map(build => ({
          ...build,
          value: build.id,
          label: build.name
        }));
        setBuildOptions(options);
      }
      const resList: any = await Promise.allSettled([
        getHouseStatusEnum(),
        getSignBillIntentEnum(),
        getHouseNatureEnum(),

      ]);
      const map = {
        houseStatus: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
        signIntentionCode: resList?.[1]?.value instanceof Array ? resList?.[1]?.value : [],
        houseNature: resList?.[2]?.value instanceof Array ? resList?.[2]?.value : [],
      }
      setDictionaryData(map);
    } catch (err) {
      console.log(err)
    }
  }

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
      setLoading(true);
      clueSalesValid({ clueId: editId, buttonKey, ...values })
            .then(res => {
              message.success(res.message || '提交有效成功');
              onClose();
              reload();
            }).finally(() => setLoading(false))
    })
  }

  const disabledDate = (current) => {
    const ninetyDaysLater = dayjs().add(3, 'month').endOf('day');
    switch (houseStatus){
      // 期房(三月后交房)
      case 'FUTURE_HOUSE':
        return current && current < ninetyDaysLater;
      // 现房(已交房)
      case 'EXISTING_HOUSE':
        return current && current > dayjs().endOf('day');
      // 准现房(三月内交房)
      case 'QUASI_EXISTING_HOUSE':
        return current && (current < dayjs().endOf('day') || current > ninetyDaysLater);
    }
  };

  const getDefaultPickerValue = () => {
    const ninetyDaysLater = dayjs().add(3, 'month').endOf('day');
    switch (houseStatus){
        // 期房(三月后交房)
      case 'FUTURE_HOUSE':
        return ninetyDaysLater.add(1, 'day');
        // 准现房(三月内交房)
      case 'QUASI_EXISTING_HOUSE':
        return dayjs().add(1, 'day').endOf('day');
      default:
        return dayjs();
    }
  }

  const dateState = (targetTimestamp) => {
    const current = dayjs(targetTimestamp)
    const threeMonthsLater = dayjs().add(3, 'month'); // 三个月后
    if (current.isAfter(threeMonthsLater)) {
      return 'FUTURE_HOUSE'; // 期房（三个月后交房）
    } else if (current.isBefore(dayjs())) {
      return 'EXISTING_HOUSE'; // 现房（已交房）
    } else {
      return 'QUASI_EXISTING_HOUSE'; // 准现房（三个月内交房）
    }
  };

  const onChangeBuilding = (option: any) => {
    console.log( option, 'change')
    form.setFieldValue( 'handoverDate', option?.handoverDate ? dayjs(option?.handoverDate) : '')
    form.setFieldValue( 'houseStatus', option?.handoverDate ? dateState(option?.handoverDate) : null)
  }

  return (
    <div className={styles.submitEffectiveModal}>
      <SDrawerOrModal
        mode="modal"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={loading}
        width={500}
        title={title || "提交有效"}
      >
        <Form
          form={form}
          name="basicInfo"
          layout="vertical"
        >
          <Form.Item
            name="buildingId"
            label="楼盘"
            rules={[
              {
                required: true,
                message: '请选择楼盘',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择楼盘'} options={buildOptions} optionFilterProp={'label'} showSearch allowClear
                    onChange={(e, option) => onChangeBuilding(option)}
            />
          </Form.Item>
          <Form.Item
            name="houseStatus"
            label="房屋状态"
            rules={[
              {
                required: true,
                message: '请选择房屋状态',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select disabled placeholder={'请选择房屋状态'} fieldNames={{label: 'description', value: 'key' }} allowClear options={dictionaryData?.['houseStatus']}
                    onChange={v => {
                      form.setFieldValue('handoverDate', v === 'EXISTING_HOUSE' ? dayjs() : null)
                    }}
            />
          </Form.Item>
          <Form.Item
            name="houseNatureCode"
            label="房屋属性"
            rules={[
              {
                required: true,
                message: '请选择房屋属性',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择房屋属性'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData?.['houseNature']} />
          </Form.Item>
          <Form.Item
            name="handoverDate"
            label="交房日期"
            rules={[
              {
                required: true,
                message: '请选择交房日期',
              },
            ]}
          >
            <DatePicker disabled style={{ width: '100%' }} disabledDate={disabledDate} defaultPickerValue={getDefaultPickerValue()}/>
          </Form.Item>
          <Form.Item
            name="constructArea"
            label="建筑面积"
            rules={[
              {
                required: true,
                message: '请填写建筑面积',
              },
            ]}
          >
            <InputNumber style={{width: '100%'}} placeholder={'请填写建筑面积'} precision={2} min={0} max={999999999} />
          </Form.Item>
          <Form.Item
            name="innerArea"
            label="套内面积"
            rules={[
              {
                required: true,
                message: '请填写套内面积',
              },
            ]}
          >
            <InputNumber style={{width: '100%'}} placeholder={'请输入套内面积'} precision={2} min={0} max={999999999}/>
          </Form.Item>
          <Form.Item
            name="signIntentionCode"
            label={<>客户意向 <Tooltip title={` A类:线索有效，且是企微好友，且有需求属性，且有装修预算，且有装修风格，且房屋状态为现房，短时间内能邀约到店
                                 B类:线索有效，且是企微好友，且有需求属性，需要花稍微多一点的时间才能邀约到店
                                 C类:线索有效，需要花大量时间才可能邀约到店`} overlayStyle={{ whiteSpace: 'pre-line' }}><QuestionCircleOutlined style={{marginLeft: 5, color: 'rgba(0, 0, 0, 0.45)'}}/></Tooltip></>}
            rules={[
              {
                required: true,
                message: '请选择客户意向',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择客户意向'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData?.['signIntentionCode']} />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}